// Ported from microsites/womens-conference/src/components/Avatar.tsx; next/image -> img.
import { fileUrl, initials } from '../lib/format';

/**
 * A person is a face, never a bare name. Photo when MP has one, warm
 * initials mark when it does not (Nancy Stewart has no contact photo yet,
 * and Elizabeth Woodson is not in MP at all).
 */
export function Avatar({
  name,
  imageGuid,
  imageSrc,
  size = 40,
  className = '',
}: {
  name: string;
  imageGuid?: string | null;
  /** A bundled portrait path; wins over the MP file when both exist. */
  imageSrc?: string | null;
  size?: number;
  className?: string;
}) {
  const src = imageSrc ?? fileUrl(imageGuid);
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={`wm-display bg-wm-sage-200 text-wm-sage-800 flex items-center justify-center rounded-full ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials(name)}
    </span>
  );
}

export function SpeakerChip({
  name,
  tagline,
  imageGuid,
  imageSrc,
}: {
  name: string;
  tagline?: string;
  imageGuid?: string | null;
  imageSrc?: string | null;
}) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <Avatar name={name} imageGuid={imageGuid} imageSrc={imageSrc} size={36} />
      <span className="leading-tight">
        <span className="block text-sm font-semibold">{name}</span>
        {tagline ? <span className="text-wm-sage-500 block text-xs">{tagline}</span> : null}
      </span>
    </span>
  );
}
